<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search ref="buttonSearch" placeholder="搜索邮箱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加背景</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->

				</template>

				<!-- 高级搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="用户ID" class="mb-0">
							<el-input size="small" v-model="from.id" placeholder="搜索ID"></el-input>
						</el-form-item>
						<el-form-item label="ArenaID" class="mb-0">
							<el-input size="small" v-model="from.u_id" placeholder="搜索ArenaID"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" class="mb-0">
							<el-input size="small" v-model="from.username" placeholder="搜索邮箱"></el-input>
						</el-form-item>
						
				

						<el-form-item label="状态" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="审核通过" :value="1"></el-option>
								<el-option label="审核失败" :value="2"></el-option>
								<el-option label="待审核" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
					


						<el-form-item label="提交时间" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				<el-table-column align="center" width="200" prop="card_number" label="申请用户">
					<template slot-scope="v">
						<el-avatar size="small" :src="v.row.head"></el-avatar>
						<!-- <div><span class="text-warning">ID：</span>{{v.row.user_id}}</div> -->
						<div><span class="text-warning">ArenaID：</span>{{v.row.u_id}}</div>
						<div><span class="text-warning">邮箱：</span>{{v.row.username}}</div>
						<div><span class="text-warning">语言：</span>{{v.row.lang_name}}</div>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="name" width="120" label="申请类型">
					<template slot-scope="v">
						<span v-if="v.row.type==1">身份证</span>
						<span v-if="v.row.type==2">护照</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="fist_name" width="120" label="姓">
				</el-table-column>
				<el-table-column align="center" prop="last_name" width="120" label="名">
				</el-table-column>


				<el-table-column align="center" prop="country.name" width="120" label="国家">
				</el-table-column>
				<el-table-column align="center" prop="number" width="200" label="证件号码">
				</el-table-column>
				<el-table-column align="center" prop="phone" width="160" label="电话">
				</el-table-column>
				<el-table-column align="center" prop="card_number" width="200" label="证件图片">
					<template slot-scope="v">
						<el-image style="width: 50px; height: 50px" v-for="(item,index) in v.row.img_arr" :key="index" :src="item"
						 :preview-src-list="v.row.img_arr">
						</el-image>
					</template>

				</el-table-column>


				<el-table-column align="center" prop="name" width="120" label="审核状态">
					<template slot-scope="v">
						<span style="color: #999;" v-if="v.row.status==0">待审核</span>
						<span style="color: green;" v-if="v.row.status==1">审核通过</span>
						<span style="color: red;" v-if="v.row.status==2">审核失败</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="remark" width="120" label="审核失败原因">

				</el-table-column>




				<el-table-column align="center" prop="admin.name" width="120" label="操作员">
				</el-table-column>


				<el-table-column sortable="custom" align="center" prop="update_time" width="200" label="提交时间">
				</el-table-column>

				<el-table-column prop="id" fixed="right" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group v-show="scope.row.status==0">
							<el-button 
							:loading="layout.loading"
							v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="is_ok(scope.row)">通过</el-button>
							<el-button v-auth="'edit'+auth_val" @click="openModel(scope.row,3)" size="mini" plain type="danger">拒绝</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog title="拒绝通过" :visible.sync="createModel" top="5vh">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="form" :model="form" label-width="100px">

			

				<el-form-item label="拒绝原因" prop="remark">
					<el-input v-model="form.remark" placeholder="拒绝原因"
					 type="textarea"
					  :rows="5"
					 clearable size="small" style="width: 90%;"></el-input>
				</el-form-item>
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索数据
				from: {
					id: '',
					u_id: '',
					username: '',
					status: -1,
					time: [],
				},
				model_title: 'Kyc',
				auth_val: 'Kyc',
				preUrl: "apply/kycList", //列表地址
				addUrl: "apply/addKyc", //添加/修改地址
			

				tableData: [],
				form: {
					id: 0,
					remark: '',
					
				},
				prop: 'create_time',
				sort: 'descending',
				rules: {
					remark: [{
							required: true,
							message: "请输入拒绝原因",
							trigger: 'blur',
						},

					]
				},
				rule_list: [],
				check_img_list: []
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('rule');
		},
		methods: {
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 关闭模态框
					}
				})
			},
			
			is_ok(item) {
				this.$confirm('确定通过此条申请吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.api.post('/apply/addKyc', {
						id: item.id,
						type: 1,
						remark:''
					}, {
						token: true
					}).then(res => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getList()
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},

			

			// 打开模态框
			openModel(e, type) {
				// 修改
				this.form = {
					id:  e.id,
					remark: '',
					type:2
				}
				this.editIndex = e.id
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				console.log(this.tableData)
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空筛选条件
			clearSearch() {
				this.from = {
					id: '',
					u_id: '',
					username: '',
					status: -1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
		}
	}
</script>

<style>
</style>
